
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/canal-de-denuncias",
      function () {
        return require("private-next-pages/canal-de-denuncias/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/canal-de-denuncias"])
      });
    }
  